export const CODE_READER_STATUS = {
  START: "start",
  STOP: "stop",
};
